import React, { useEffect, useRef } from 'react';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';
function Gallery() {
    const isotopeContainer = useRef(null);
    const isotopeInstance = useRef(null);
    const lightboxRef = useRef(null);
    useEffect(() => {
        let iso;

        const imgLoad = imagesLoaded(isotopeContainer.current, () => {
            iso = new Isotope(isotopeContainer.current, {
                itemSelector: '.portfolio-item',
                layoutMode: 'masonry',
                getSortData: {
                    name: '.name',
                },
            });
            isotopeInstance.current = iso;
        });

        return () => {
            if (iso) {
                iso.destroy();
            }
        };
    }, []);
    useEffect(() => {
        // Initialize GLightbox
        lightboxRef.current = GLightbox({
            selector: '.glightbox',
            touchNavigation: true,
            loop: true,
            zoomable: true,
            autoplayVideos: true,
        });

        return () => {
            // Clean up on unmount
            if (lightboxRef.current) {
                lightboxRef.current.destroy();
            }
        };
    }, []);
    return (
        <>
            <div id="hero" className="Starter section dark-background">
                <img src="assets/img/image2.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                <div className="container">
                    <div className="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-xl-6 col-lg-8">
                            <h2>Explore Our Truck Gallery<span>.</span></h2>
                            <p>Discover our wide range of trucks in action — from powerful engines to rugged builds, each one tells a story of performance and reliability.</p>
                        </div>
                    </div>
                </div>
            </div>
            <section id="portfolio" class="portfolio section">

                <div class="container section-title" data-aos="fade-up">
                    <h2>Gallery</h2>
                    <p>Check our Gallery</p>
                </div>

                <div class="container">

                    <div class="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order" >

                        {/* <ul class="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="100">
                            <li data-filter="*" class="filter-active">All</li>
                            <li data-filter=".filter-app">App</li>
                            <li data-filter=".filter-product">Card</li>
                            <li data-filter=".filter-branding">Web</li>
                        </ul> */}

                        <div class="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="200" ref={isotopeContainer}>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <img src="assets/img/img3.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Real-Time Truck Tracker</h4>
                                    <p>Track truck locations, routes, and status in real-time.</p>
                                    <a href="assets/img/img3.jpeg" title="Real-Time Truck Tracker" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/img4.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Heavy-Duty Haulers</h4>
                                    <p>Reliable trucks built for long-distance freight.</p>
                                    <a href="assets/img/img4.jpeg" title="Heavy-Duty Haulers" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                <img src="assets/img/img6.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Fleet Branding</h4>
                                    <p>Custom truck designs that carry your brand identity.</p>
                                    <a href="assets/img/img6.jpeg" title="Fleet Branding" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                            {/* <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <img src="assets/img/img5.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Tracking Dashboard</h4>
                                    <p>App integration for live truck tracking and updates.</p>
                                    <a href="assets/img/img5.jpeg" title="Tracking Dashboard" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div> */}

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/img7.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Long-Route Trailers</h4>
                                    <p>Designed for high-capacity and extended hauls.</p>
                                    <a href="assets/img/img7.jpeg" title="Long-Route Trailers" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                            {/* <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                <img src="assets/img/img8.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Branded Delivery Trucks</h4>
                                    <p>Fleet visuals that represent your business on the road.</p>
                                    <a href="assets/img/img8.jpeg" title="Branded Delivery Trucks" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div> */}

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <img src="assets/img/img9.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Smart Fleet App</h4>
                                    <p>Monitor, manage, and maintain all truck operations.</p>
                                    <a href="assets/img/img9.jpeg" title="Smart Fleet App" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/image19.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Container Movers</h4>
                                    <p>Specialized trucks for containerized cargo transport.</p>
                                    <a href="assets/img/image19.jpeg" title="Container Movers" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                <img src="assets/img/image20.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Visual Identity Fleet</h4>
                                    <p>Turn your trucks into rolling billboards with sharp branding.</p>
                                    <a href="assets/img/image20.jpeg" title="Visual Identity Fleet" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/image25.jpg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                                <div class="portfolio-info">
                                    <h4>Heavy-Duty Haulers</h4>
                                    <p>Reliable trucks built for long-distance freight.</p>
                                    <a href="assets/img/image25.jpg" title="Heavy-Duty Haulers" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </>

    )
}

export default Gallery;